import { useTranslation } from 'react-i18next'

import { ArrowCounterClockwiseIcon, CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import {
  codeStates,
  decisions,
} from '@/inventory/pages/InventoryPage/FixInventoryItemsDrawer/steps/ReviewRecommendationsStep/DraftItemsList/DraftItem/constants'

import * as Styles from './styles'

const Actions = ({ codeState, decision, onAccept, onDiscard, onUndo, onRestore }) => {
  const { t } = useTranslation()

  if (codeState === codeStates.match) return null

  if (decision === decisions.pending) {
    return (
      <Styles.ActionsRow>
        <Button size="s" color="danger" variant="outlined" onClick={onDiscard}>
          <XCircleIcon size={16} />
          {t('Descartar')}
        </Button>
        <Button size="s" color="success" onClick={onAccept}>
          <CheckCircleIcon size={16} /> {t('Aceptar')}
        </Button>
      </Styles.ActionsRow>
    )
  }

  if (decision === decisions.accepted) {
    return (
      <Button variant="text" onClick={onUndo} size="s">
        {t('Deshacer')}
      </Button>
    )
  }

  if (decision === decisions.discarded) {
    return (
      <Button variant="text" size="s" onClick={onRestore}>
        <ArrowCounterClockwiseIcon />
        {t('Volver a recomendación')}
      </Button>
    )
  }

  return null
}

export default Actions
